import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-btn-block"
}
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { class: "admin-info" }

import { onMounted, onBeforeUnmount, computed } from 'vue'
import { useWebSocketStore } from '@/store/websocket.store'
import { useAuthStore } from '@/store/auth'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import { api } from '@/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const wsStore = useWebSocketStore()
const authStore = useAuthStore()
const router = useRouter()

const isAdmin = computed(() => authStore.isAdmin)
const adminsOnline = computed(() => wsStore.adminsOnline)

// const initWebSocket = () => {
//   if (isAdmin.value && !wsStore.isConnected) {
//     wsStore.connect();
//
//     // wsStore.subscribe("auction_data", (data) => {
//     //   console.log("🔄 Auction update:", data);
//     // });
//
//     // wsStore.subscribe("price_stats", (data) => {
//     //   console.log("📊 Price stats received:", data);
//     // });
//   }
// };

// watch(
//   isAdmin,
//   (newVal) => {
//     if (newVal) {
//       initWebSocket();
//     } else {
//       wsStore.disconnect();
//     }
//   },
//   { immediate: true }
// );

const cleanupWebSocket = () => {
  wsStore.listeners.clear()
  wsStore.disconnect()
}

onBeforeUnmount(() => {
  cleanupWebSocket()
})

const handleLogout = () => {
  authStore.logout()
  router.push('/login')
  cleanupWebSocket()
}

onMounted(() => {
  authStore.init()
})

async function subscribeToPush() {
  const permission = await Notification.requestPermission()

  if (permission !== 'granted') {
    alert('Разрешите уведомления для подписки')
    return
  }

  const register = await navigator.serviceWorker.register('/sw.js')
  const publicKey =
    'BJ94Ds_fnz53GbYp3iCcShyg9U6sOoxxgF6GivAaLZtGwubwlVrD8C57AoFeKej1bOvoYinD4W0r9by1_Wn4sNc'

  const subscription = await register.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey)
  })

  await api.post('/push/subscribe', subscription)

  alert('Подписка оформлена')
}

// utils
function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)))
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_unref(Toast)),
    (isAdmin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Главная", -1)
              ])),
              _: 1,
              __: [0]
            }),
            _createVNode(_component_router_link, { to: "/admin" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Админ-панель", -1)
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(_component_router_link, { to: "/artifacts" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Артефакты", -1)
              ])),
              _: 1,
              __: [2]
            }),
            _createVNode(_component_router_link, { to: "/tracked-artefacts" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Отслеживание", -1)
              ])),
              _: 1,
              __: [3]
            }),
            _createVNode(_component_router_link, { to: "/module" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("История модулей", -1)
              ])),
              _: 1,
              __: [4]
            }),
            _createVNode(_component_router_link, { to: "/module-stat" }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Анализ модулей", -1)
              ])),
              _: 1,
              __: [5]
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(" Администратор: " + _toDisplayString(_unref(authStore)?.user?.username) + " ", 1),
              _createElementVNode("button", {
                onClick: handleLogout,
                class: "admin-btn"
              }, "Выйти"),
              _createElementVNode("div", null, [
                _createElementVNode("button", { onClick: subscribeToPush }, "Рассылка")
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adminsOnline.value, (i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(i), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})